const dt = new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Asia/Dhaka' });
const d0 = new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeZone: 'Asia/Dhaka' });
export const fmtDT = (v?: string | Date | null): string => (v ? dt.format(new Date(v)) : '—');
export const fmtD = (v?: string | Date | null): string => (v ? d0.format(new Date(v)) : '—');
export const taka = (v?: string | number | null): string => (v === null || v === undefined || v === '' ? '—' : `৳${Number(v).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`);
export const ago = (v?: string | Date | null): string => {
  if (!v) return '—';
  const s = Math.round((Date.now() - new Date(v).getTime()) / 1000);
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86400) return `${Math.floor(s / 3600)} h ago`;
  return `${Math.floor(s / 86400)} d ago`;
};
export const short = (id?: string | null): string => (id ? id.slice(0, 8) : '—');
export const humanize = (s: string): string => s.replace(/[_.]/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
